import { callLoginApi } from './apiRegister';
import { callApi } from './apiService';
import { Router } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export const getOrgs = async (params = {}) => {
  return await callApi('/api/Data/Orgs', 'GET', null, params);
};
export const getOrgTree = async (params = {}) => {
  return await callApi('/api/data/OrgTree', 'GET', null, params);
};

export const getCodeGozari = async () => {
  return await callApi('/api/Data/BaseInfo?cat=5', 'GET');
};

export const getCountryLocation = async () => {
  return await callApi('/api/data/locations?type=5', 'GET');
};

export const getDataSubjects = async () => {
  return await callApi('/api/data/subjects', 'GET');
};
export const getSubjectsList = async () => {
  return await callApi('/api/data/subjects?metheod=0', 'GET');
};
export const getLawTypes = async () => {
  return await callApi('/api/Data/LawTypes', 'GET');
};

export const getProvinceLocation = async () => {
  return await callApi('/api/data/locations?type=6', 'GET');
};

export const getStatus = async () => {
  return await callApi('/api/data/Status', 'GET');
};

export const loginWithJWT = async (email, password) => {
  const response = await callApi('/api/Account/Login', 'POST', {
    UserName: email,
    password: password,
  });
  console.log('Login', response);
  localStorage.setItem('tokenLogin', response.token);
  return response;
};

export const fetchRefreshToken = async (token, email, setTokenLogin) => {
  const response = await callApi(
    '/api/Account/RefreshTokenRegeneration',
    'POST',
    {
      Token: token?.refreshToken,
      UserName: email,
    },
    null,
    {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
      'Access-Control-Allow-Headers':
        'X-Requested-With, Content-Type, Authorization',
      'Access-Control-Allow-Credentials': 'true',
    }
  );
  //setTokenLogin(response);
  return response;
};

export const fetchLoginProfileJWT = async (email, password) => {
  if (email === null || email === '' || email === undefined)
    return Promise.resolve(null);
  return await callLoginApi(
    '/v1/Account/Login',
    'POST',
    {
      UserName: email,
      password: password,
    },
    (data) => {
      console.log('data', data);
      if (data?.data.accessToken) {
        console.log('object', data);
        // Router('/');
window.location.assign("/")
        // fetchLoginJWT(email, password);
      }
    }
  );
};

export const fetchLoginJWT = async (email, password) => {
  if (email === null || email === '' || email === undefined)
    return Promise.resolve(null);
  const response = await callApi('/api/Account/Login', 'POST', {
    UserName: email,
    password: password,
  });
  // console.log('response', response);
  if (response.data?.accessToken) {
    console.log('condition ', response.data);
    localStorage.setItem('tokenLogin', JSON.stringify(response));
  }
  return response;
};

export const NewRegisterWithPhoneNumberFun = async (userInfo, code) => {
  if (userInfo === null || userInfo === '' || userInfo === undefined)
    return Promise.resolve(null);
  return await callLoginApi(
    '/v1/Account/RegisterUserWithPhoneNumber',
    'POST',
    {
      firstName: userInfo.fName,
      lastName: userInfo.LName,
      phoneNumber: userInfo.phoneNumber,
      code: code,
    },
    (data) => {
      if (data?.accessToken) {
        //const userInfo = jwtDecode(data.data?.accessToken);
        // setCurrentUser(userInfo);
        Router('/');
      }
    },
    {
      'Content-Type': 'application/json',
    }
  );
  //setTokenLogin(token.data);
};
export const NewLoginWithPhoneNumber = async (phoneNum, code) => {
  if (phoneNum === null || phoneNum === '' || phoneNum === undefined)
    return Promise.resolve(null);
  return await callLoginApi(
    '/v1/Account/LoginWithPhoneNumber',
    'POST',
    {
      phoneNumber: `${phoneNum}`,
      code: code,
    },
    (data) => {
      if (data?.accessToken) {
        //const userInfo = jwtDecode(data.data?.accessToken);
        // setCurrentUser(userInfo);
        Router('/');
      }
    },
    {
      'Content-Type': 'application/json',
    }
  );
  //setTokenLogin(token.data);
};

export const NewRegisterWithPhoneNumber = async (phoneNum, code) => {
  return await callLoginApi(
    '/v1/Account/RegisterUserWithPhoneNumber',
    'POST',
    {
      phoneNumber: phoneNum,
      code: code,
    },
    (data) => {
      if (data?.accessToken) {
        //const userInfo = jwtDecode(data.data?.accessToken);
        // setCurrentUser(userInfo);
        window.location.assign(
          `${
            window.location.pathname === '/login'
              ? '/'
              : window.location.pathname
          }`
        );
      }
    },
    {
      'Content-Type': 'application/json',
    }
  );
  //setTokenLogin(token.data);
};
export const newFetchRefreshToken = async (setCurrentUserCookie) => {
  const CookieToken = JSON.parse(Cookies.get('token'));
  const response = await callLoginApi(
    '/v1/Account/RefreshTokenRegeneration',
    'POST',
    {
      Token: CookieToken?.data.refreshToken,
      UserName: jwtDecode(CookieToken?.data.accessToken).userName,
    },
    null,
    {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
      'Access-Control-Allow-Headers':
        'X-Requested-With, Content-Type, Authorization',
      'Access-Control-Allow-Credentials': 'true',
    }
  );

  const cookieOptions = {
    expires: 365 * 100, // 100 years
    secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
    sameSite: process.env.REACT_APP_COOKIE_SAMESITE || 'strict',
  };

  // Add domain attribute if specified in .env
  if (process.env.REACT_APP_COOKIE_DOMAIN) {
    cookieOptions.domain = process.env.REACT_APP_COOKIE_DOMAIN;
  }

  // Set the cookie
  Cookies.set('token', `${JSON.stringify(response.data)}`, cookieOptions);

  const userInfo = jwtDecode(response.data?.accessToken);
  setCurrentUserCookie(userInfo);
  return response;
};

export const GetListSubject = async (ID, LwTDataID) => {
  const CookieToken = JSON.parse(Cookies.get('token'));
  console.log('id', ID);
  const response = await callApi(
    '/v1/UserLwSubject/UserLwSubjectList',
    'POST',
    JSON.stringify({
      filters: {
        pageNumber: 1,
        pageSize: 20,
        isSortAscending: true,
        sortField: '',
        search: '',
      },
      subjectType: 4,
      lwSubjectId: Number(ID),
    }),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${CookieToken?.data.accessToken}`,
    },
    true // مقدار true نشان دهنده این است که این آدرس در پروفایل است
  );
  console.log(response, 'res1');

  const response2 = await fetchDataLwSubjectTree(Number(ID), LwTDataID);
  const result = {
    ...response2,
    TreeID: Number(ID),
  };
  return result;
};
export const GetUserLwSubject = async (pageNumber, searchText, id) => {
  const CookieToken = JSON.parse(Cookies.get('token'));
  // console.log(Params, searchText);
  console.log('DDDDDDDD', id);
  console.log('PPPPPPP', pageNumber);
  return await callApi(
    '/v1/UserLwSubject/UserLwSubjectTreeList',
    'POST',
    JSON.stringify({
      filters: {
        pageNumber: pageNumber,
        pageSize: 100,
        isSortAscending: true,
        sortField: '',
        search: '',
      },
      title: searchText,
      rootId: id,
    }),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${CookieToken?.data.accessToken}`,
    },
    true // مقدار true نشان دهنده این است که این آدرس در پروفایل است
  );
};

export const fetchDataLwSubjectTree = async (ID, LwTDataID) => {
  const CookieToken = JSON.parse(Cookies.get('token'));
  console.log(ID, 'idqdqdqqdddd');

  const response = await callApi(
    '/v1/UserLwSubject/SubjectsTree',
    'POST',
    JSON.stringify({
      tabvib: true,
      addroot: false,
      parentId: 0,
      lwSubjectId: LwTDataID === null ? Number(ID) : LwTDataID,
    }),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${CookieToken?.data.accessToken}`,
    },
    true // مقدار true نشان دهنده این است که این آدرس در پروفایل است
  );
  // console.log('response', response);
  return response;
};

export const SendMessage = async (text, title) => {
  const CookieToken = JSON.parse(Cookies.get('token'));
  const response = await callApi(
    '/v1/UserNote/CreateUserNote',
    'POST',
    JSON.stringify({
      lawId: null,
      sectionId: null,
      parentId: 0,
      text: text,
      title: title,
      isPublic: true,
      isPublish: true,
      userNoteType: 7,
    }),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${CookieToken?.data.accessToken}`,
    },
    true
  );
  if (response.statusCode == 200) {
    alert(
      `فرهیخته گرامی، با سپاس از حسن همرامی شما با این سامانه، پیام شما با شناسه ${response.data} ثبت گردید. کارشناسان سامانه در اولین فرصت پاسخگوی شما هم وطن عزیز خواهند بود. برای پیگیری و مشاهده پاسخ پیام خویش لطفا به پروفایل عمومی سامانه به نشانی my.ilaws.net مراجعه بفرمایید. از این که با نظرات ارزشمند خویش ما را در تکمیل و ارتقای این سامانه ملی یاری می رسانید صمیمانه سپاسگزاریم. `
    );
  }
  return response;
};
export const FetchDraftComperhensiveLaw = async (ID, pageNumber, size) => {
  console.log('ID', ID);
  return await callApi(
    `/api/Subject/ComprehensiveLaw?subject=${ID}`,
    'POST',
    JSON.stringify({
      pageNumber: 1,
      pageSize: 50,
      isSortAscending: true,
      sortField: '',
      search: '',
    }),
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchData = async () => {
  return await callApi('/api/data?id=1', 'GET');
  //setData(data);
};

export const fetchLaw = async (func, resPerPage = 10, currentPage = 1) => {
  return await callApi(
    `/api/law/index?types=1&size=${resPerPage}&page=${currentPage}`
  );
};
export const GetMoreView = async () => {
  const response = await callApi(
    `/v1/Visit/MostVisitedLawCount?isMyVisited=false`,
    'post',
    {},
    {
      'Content-Type': 'application/json',
    },
    null,
    true
  );
  return response;
};
export const fetchMogharare = async (resPerPage = 10, currentPage = 1) => {
  return await callApi(
    `/api/law/index?types=2&size=${resPerPage}&page=${currentPage}`,
    'GET'
  );
  //setMogharare(mogharar.data);
};
export const fetchRay = async (resPerPage = 10, currentPage = 1) => {
  return await callApi(
    `/api/law/index?types=3&size=${resPerPage}&page=${currentPage}`,
    'GET'
  );
  //setRay(raay.data);
};
export const fetchComment = async (resPerPage = 10, currentPage = 1) => {
  return await callApi(
    `/api/law/index?types=4&size=${resPerPage}&page=${currentPage}`,
    'GET'
  );
  //setComment(Comment.data);
};
export const fetchReportStatistic = async () => {
  return await callApi('/api/Report/Statistic', 'GET');
  //setStatistic(statistic);
};

export const fetchSub = async () => {
  return await callApi('/api/Data/Subjects?metheod=0', 'GET', null, null, {
    'Content-Type': 'application/json',
  });
  //setSubjectList(data);
};
export const fetchSearchLi = async () => {
  return await callApi('/api/Data/Subjects?metheod=1', 'GET', null, null, {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
    'Access-Control-Allow-Headers':
      'X-Requested-With, Content-Type, Authorization',
    'Access-Control-Allow-Credentials': 'true',
  });
};
export const fetchCountSearchLi = async (subjects) => {
  if (subjects === null || subjects === '' || subjects === undefined)
    return Promise.resolve(null);
  return await callApi(
    `/api/law/index?subjects=${subjects}&methodsId=1`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchSearchLiForBoxContentMozaot = async (
  subjects,
  // statusE,
  // types,
  page
) => {
  if (subjects === null || subjects === '' || subjects === undefined)
    return Promise.resolve(null);
  // if (subjects === null || subjects === "") {
  //   return await callApi(
  //     `/api/Law/Index?search=&subjects=${subjects}&states=${
  //       statusE !== "" ? "&states=" + statusE : ""
  //     }&size=13${
  //       types !== undefined || types !== 0 ? "&types=" + types : ""
  //     }&page=${page}`,
  //     "GET",
  //     null,
  //     null,
  //     {
  //       "Content-Type": "application/json",
  //     }
  //   );
  // } else {
  return await callApi(
    `/api/Law/Index?subjects=${subjects}&methodsId=1&size=13&page=${page}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
// }
export const BaseInfoCat1 = async () => {
  return await callApi(`/api/Data/BaseInfo?cat=1`, 'GET', null, null, {
    'Content-Type': 'application/json',
  });
};
export const LawReport24 = async () => {
  return await callApi(`/api/Report/LawReport?id=24`, 'GET', null, null, {
    'Content-Type': 'application/json',
  });
};
export const AdvSearch = async (searchText, pageNumber) => {
  return await callApi(
    `/api/AdvSearch/SearchTitle?search=${searchText}&size=30&page=${pageNumber}&order=0&selector=2&isSynonym=false&isStopWord=false&isHighlighted=false`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchDataPlan = async (itemsPerPage = 10, pagePlan = 1) => {
  return await callApi(
    `/api/Law/Index?types=5&size=${itemsPerPage}&page=${pagePlan}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchDataLayer = async (itemsPerPage = 10, pagePlan = 1) => {
  return await callApi(
    `/api/Law/Index?types=6&size=${itemsPerPage}&page=${pagePlan}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchSimilarityOfParagraphs = async (id, page = 1) => {
  if (id === null || id === '' || id === undefined)
    return Promise.resolve(null);
  return await callApi(
    `/api/Plan/SimilarityOfParagraphs?id=3&size=30&page=${page}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};

export const FetchSubjectTreeList = async (id) => {
  console.log("id in fun",id)
  // if (id === null || id === '' || id === undefined)
  //   return Promise.resolve(null);
  return await callApi(
    `/api/Subject/SubjectTreeList?id=${id}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};




export const fetchRelationIndex = async (
  // txtSearch = '',
  // statusE = '',
  // subjects = '',
  // noeNaskh = '',
  // rozname = '',
  // taeed = '',
  // sizeTanghih = 30,
  // pageTanghih = 1
  txtSearch,
  statusE,
  subjects,
  noeNaskh,
  rozname,
  taeed,
  sizeTanghih,
  pageTanghih
) => {
  console.log(
    'fetchRelationIndex',
    txtSearch,
    statusE,
    subjects,
    noeNaskh,
    rozname,
    taeed,
    sizeTanghih,
    pageTanghih
  );

  if (sizeTanghih === 8) return Promise.resolve(null);
  return await callApi(
    // `/api/Law/RelationIndex?${
    //   txtSearch != undefined ? `search=` + txtSearch : ''
    // }${statusE != undefined ? `&states=` + statusE : ''}${
    //   subjects != undefined ? `&subjects=` + subjects : ''
    // }${noeNaskh != undefined ? `&whole=` + noeNaskh : ''}${
    //   rozname != undefined ? `&inNews=` + rozname : ''
    // }${taeed != undefined ? `&isCheck=` + taeed : ''}${
    //   sizeTanghih != undefined ? `&size=` + sizeTanghih : ''
    // }${pageTanghih != undefined ? `&page=` + pageTanghih : ''}`,
    `/api/Law/RelationIndex?search=${txtSearch}&states=${statusE}&subjects=${subjects}&whole=${noeNaskh}&inNews=${rozname}&isCheck=${taeed}&size=${sizeTanghih}&page=${pageTanghih}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const fetchTreeLaw = async (id) => {
  if (id === null || id === '' || id === undefined)
    return Promise.resolve(null);
  return await callApi(`/api/law/tree?law_id=${id}`, 'GET', null, null, {
    'Content-Type': 'application/json',
  });
};
export const fetchSubjectsTree = async () => {
  return await callApi('/api/data/SubjectsTree', 'GET');
};
export const fetchSearchResults = async (searchParams) => {
  if (
    searchParams === null ||
    searchParams?.length === 0 ||
    searchParams === undefined
  )
    return Promise.resolve(null);
  return await callApi(`/api/Law/Index?${searchParams}`, 'GET', null, null, {
    'Content-Type': 'application/json',
  });
};
export const fetchExecutiveDevices = async (orgsId, types, page) => {
  if (types === null || types === '' || orgsId === undefined)
    return Promise.resolve(null);
  return await callApi(
    `/api/Law/Index?xorgs=${orgsId}&types=${types}&page=${page}&size=100`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
// export const fetchApprovalAuthorities = async (orgs, types) => {
//   if (
//     types === null ||
//     types === "" ||
//     orgs === undefined
//   )
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/law/Count?&orgs=${orgs}&types=${types}`,
//     "GET",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//     }
//   );
// };

export const fetchApprovalAuthorities = async (
  pageTasvib,
  sizeTasvib,
  orgs,
  types
) => {
  if (types === null || types === '' || orgs === undefined)
    return Promise.resolve(null);
  return await callApi(
    `/api/Law/Index?page=${pageTasvib}${
      orgs !== '' ? '&orgs=' + orgs : ''
    }&size=${sizeTasvib}&${
      types !== 0 || types !== undefined ? 'types=' + types : ''
    }`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};

// .................... view text .....................

// export const PlayReadText = async (id) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(`/audio/${id}.mp3`, "GET", null, null, {
//     "Content-Type": "application/json",
//   });
// };

// export const handleClickIconTextView = async (sectionId, LawId) => {
//   if (sectionId === null || sectionId === "" || LawId === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Law/RelationIndex?Section_ID=${sectionId}&Law_ID=${LawId}`,
//     "GET",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//     }
//   );
// };
// export const fetchSectionSimilarity = async (id, isSynonym) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Nlp/SectionSimilarity?sectionId=${id}&isSynonym=${isSynonym}`,
//     "GET",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//     }
//   );
// };
// export const fetchOpenInfoSubjectsFun = async (id) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Nlp/SectionSimilarity?sectionId=${id}&isSubject=true`,
//     "GET",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//     }
//   );
// };
// export const fetchSectionSubject = async (id) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Law/SectionSubject?sectionid=${id}`,
//     "GET",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//     }
//   );
// };
// export const fetchConfirmSubjectIsTrue = async (
//   subjectid,
//   sectionid,
//   tokenLogin
// ) => {
//   if (subjectid === null || subjectid === "" || subjectid === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Admin/ConfirmSubject?isConfirm=true${
//       subjectid && `&subject_ID=${subjectid}`
//     }${sectionid !== undefined ? `&section_ID=${sectionid}` : ""}`,
//     "POST",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${tokenLogin?.accessToken}`,
//     }
//   );
// };
// export const ConfirmSubjectIsTrueTitle = async (
//   subjectid,
//   lawid,
//   tokenLogin
// ) => {
//   if (subjectid === null || subjectid === "" || subjectid === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Admin/ConfirmSubject?isConfirm=true${
//       subjectid && `&subject_ID=${subjectid}`
//     }${lawid !== undefined ? `&law_ID=${lawid}` : ""}`,
//     "POST",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${tokenLogin?.accessToken}`,
//     }
//   ).then((res) => {
//     if (res.status === 200) alert("عملیات با موفقیت انجام شد ");
//   });
// };

// export const ConfirmSubjectIsFalse = async (
//   subjectid,
//   sectionid,
//   tokenLogin
// ) => {
//   if (subjectid === null || subjectid === "" || subjectid === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Admin/ConfirmSubject?isConfirm=false${
//       subjectid && `&subject_ID=${subjectid}`
//     }${sectionid !== undefined ? `&section_ID=${sectionid}` : ""}`,
//     "POST",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${tokenLogin?.accessToken}`,
//     }
//   ).then((res) => {
//     if (res.status === 200) alert("عملیات با موفقیت انجام شد ");
//   });
// };

// export const ConfirmSubjectIsFalseTitle = async (
//   subjectid,
//   lawid,
//   tokenLogin
// ) => {
//   if (subjectid === null || subjectid === "" || subjectid === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Admin/ConfirmSubject?isConfirm=false${
//       subjectid && `&subject_ID=${subjectid}`
//     }${lawid !== undefined ? `&law_ID=${lawid}` : ""}`,
//     "POST",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${tokenLogin?.accessToken}`,
//     }
//   ).then((res) => {
//     if (res.status === 200) alert("عملیات با موفقیت انجام شد ");
//   });
// };

// export const ConfrimText = async (id, isConfirmText, tokenLogin) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(
//     `/api/Admin/ConfirmText?id=${id}&isConfirmText=${isConfirmText}`,
//     "POST",
//     null,
//     null,
//     {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${tokenLogin?.accessToken}`,
//     }
//   ).then((res) => {
//     if (res.status === 200) GetConfrimLaw();
//   });
// };

// export const GetConfrimLaw = async (id, tokenLogin) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(`/api/Admin/GetConfirmLaw?id=${id}`, "GET", null, null, {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${tokenLogin?.accessToken}`,
//   }).then((res) => {
//     if (res.status === 200) alert("عملیات با موفقیت انجام شد ");
//   });
// };
// export const FindLawFun = async (id) => {
//   if (id === null || id === "" || id === undefined)
//     return Promise.resolve(null);
//   return await callApi(`/api/Admin/GetLaw?id=${id}`, "GET", null, null, {
//     "Content-Type": "application/json",
//     //Authorization: `Bearer ${tokenLogin?.accessToken}`,
//   }).then((res) => {
//     if (res.status === 200) alert("عملیات با موفقیت انجام شد ");
//   });
// };
// .................... view text .....................
export const getAdvanceSearch = async (
  keyWordSearch,
  pageSizeAdvance,
  pageAdvance,
  subjects,
  typeFlag,
  statusE,
  orgs,
  orgsId,
  ApproveDate,
  toApproveDate,
  locationsId,
  checkedSinoname,
  partOfWord,
  searchContent,
  valueSelector,
  isOrder,
  // isRevision,
  isRepealed,
  types,
  lawTypeIds
) => {
  if (
    pageAdvance === null ||
    // pageAdvance === "" ||
    pageAdvance === undefined ||
    pageAdvance === NaN
  )
    return Promise.resolve(null);
  return await callApi(
    `/api/advsearch/search?search=${keyWordSearch ? keyWordSearch : ''}&size=${
      pageSizeAdvance ? pageSizeAdvance : ''
    }${pageAdvance === 1 ? '' : '&page=' + pageAdvance}${
      subjects && !typeFlag ? '&subjects=' + subjects : ''
    }${statusE ? '&statuses=' + statusE : ''}${orgs ? '&orgs=' + orgs : ''}${
      orgsId ? '&orgsId=' + orgsId : ''
    }&fromDate=${ApproveDate ? ApproveDate : ''}&toDate=${
      toApproveDate ? toApproveDate : ''
    }&locationsId=${locationsId ? locationsId : ''}${
      checkedSinoname ? '&isSynonym=' + checkedSinoname : ''
    }${partOfWord ? '&isPartOfWord=' + partOfWord : ''}${
      searchContent
        ? '&searchContent=' + searchContent
        : searchContent == 0
        ? '&searchContent=0'
        : ''
    }${valueSelector ? '&selector=' + valueSelector : ''}${
      isOrder ? '&order=' + isOrder : ''
    }${
      isRepealed != undefined || isRepealed != null
        ? isRepealed == true
          ? '&isRepealed='
          : '&isRepealed=false'
        : ''
    }${types == undefined ? '' : '&types=' + types}${
      lawTypeIds != 0 || lawTypeIds != undefined
        ? '&lawTypeIds=' + lawTypeIds
        : ''
    }${valueSelector == 2 ? '&isStopWord=false' : ''}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};

export const fetchApprovalAuthoritiesAdvanceSearch = async (
  pageNumber,
  searchText
) => {
  if (pageNumber === null || pageNumber === '' || pageNumber === undefined)
    return Promise.resolve(null);
  return await callApi(
    `/api/Data/Orgs?size=50&page=${pageNumber}&search=${searchText}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
export const getSubjectInfo = async (id, infoType) => {
  console.log(id, infoType);
  return await callApi(
    `/api/Subject/SubjectInfo?id=${id}&info=${infoType}`,
    'GET',
    null,
    null,
    {
      'Content-Type': 'application/json',
    }
  );
};
